import { render, staticRenderFns } from "./non-reception.vue?vue&type=template&id=36bf32c4"
import script from "./non-reception.vue?vue&type=script&lang=ts"
export * from "./non-reception.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports